<div class="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm animate-fade-in">
  <div
    class="relative bg-white dark:bg-slate-900 rounded-[2.5rem] shadow-2xl w-full max-w-sm border border-slate-100 dark:border-slate-800/80 animate-fade-in-up flex flex-col"
    style="max-height: 88vh;">

    <!-- Top accent bar -->
    <div
      class="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-[85%] h-2 bg-gradient-to-r from-amber-200 via-[#fdbf3a] to-amber-200 flex-shrink-0 rounded-b-xl z-10">
    </div>

    <!-- Non-printable header (centered like receipt component) -->
    <div class="px-6 pt-6 pb-2 flex-shrink-0 flex flex-col items-center">
      <div
        class="w-12 h-12 bg-amber-50 dark:bg-amber-950/20 rounded-2xl flex items-center justify-center mb-2 shadow-sm border border-amber-100 dark:border-amber-900/30 flex-shrink-0">
        <span class="material-icons text-[#fdbf3a] !text-2xl">receipt_long</span>
      </div>
      <h1 class="text-[17px] font-black text-slate-800 dark:text-slate-100 tracking-tight">ใบเสร็จรับเงิน</h1>
      <span
        class="inline-block mt-1.5 px-2.5 py-0.5 rounded-full text-[9px] font-extrabold tracking-wider bg-emerald-50 dark:bg-emerald-950/20 text-emerald-600 dark:text-emerald-400 border border-emerald-100 dark:border-emerald-900/30 uppercase">
        ชำระเงินสำเร็จ / PAID
      </span>
    </div>

    <!-- Scrollable receipt body — min-h-0 ensures flex child can shrink & scroll -->
    <div class="overflow-y-auto flex-1 min-h-0 px-6 pb-3 custom-scrollbar">

      <!-- ===== PRINTABLE RECEIPT ===== -->
      <div id="printable-receipt" #receiptRef class="bg-transparent py-4">

        <!-- Thermal Paper Container -->
        <div class="thermal-receipt py-8 px-6 rounded-[2px] receipt-bg-white relative">

          <!-- Zigzag top -->
          <div class="zigzag-top">
            <svg class="w-full h-full text-white fill-current block" viewBox="0 0 100 10" preserveAspectRatio="none">
              <polygon
                points="0,10 2.5,0 5,10 7.5,0 10,10 12.5,0 15,10 17.5,0 20,10 22.5,0 25,10 27.5,0 30,10 32.5,0 35,10 37.5,0 40,10 42.5,0 45,10 47.5,0 50,10 52.5,0 55,10 57.5,0 60,10 62.5,0 65,10 67.5,0 70,10 72.5,0 75,10 77.5,0 80,10 82.5,0 85,10 87.5,0 90,10 92.5,0 95,10 97.5,0 100,10" />
            </svg>
          </div>

          <!-- Header: Company info -->
          <div class="text-center pb-2">
            <h2 class="text-[17px] font-extrabold tracking-widest receipt-text-dark receipt-mono">CITY PARKING</h2>
            <p class="text-[9.5px] receipt-text-gray-500 leading-relaxed mt-1 font-medium max-w-[85%] mx-auto">
              45/4 หมู่ 5 ต.บางเมือง อ.เมืองสมุทรปราการ จ.สมุทรปราการ 10270<br />
              โทรศัพท์: 02-096-2255
            </p>
            <div class="receipt-dashed-line"></div>
            <p class="text-[11px] font-bold tracking-wider receipt-text-dark receipt-mono mt-1">
              ใบเสร็จรับเงิน
            </p>
          </div>

          <div class="receipt-dashed-line"></div>

          <!-- Meta Info -->
          <div class="space-y-2 py-1">
            <div class="flex justify-between items-center text-[11.5px] receipt-text-dark">
              <span class="font-medium receipt-text-gray-500">เลขที่ใบเสร็จ</span>
              <span class="font-bold receipt-mono receipt-text-dark">{{ record?.receiptId || '-' }}</span>
            </div>
            <div class="flex justify-between items-center text-[11.5px] receipt-text-dark">
              <span class="font-medium receipt-text-gray-500">วันที่รับชำระ</span>
              <span class="font-bold receipt-mono receipt-text-dark">{{ formatDateDisplay(record?.paidDate) }}</span>
            </div>
            <div class="flex justify-between items-center text-[11.5px] receipt-text-dark">
              <span class="font-medium receipt-text-gray-500">ประเภทการชำระ</span>
              <span class="font-bold receipt-text-dark">{{ record?.feeTypeName || '-' }}</span>
            </div>
            <div class="flex justify-between items-start text-[11.5px] receipt-text-dark">
              <span class="font-medium receipt-text-gray-500">ลานจอดรถ</span>
              <span class="font-bold receipt-text-dark text-right max-w-[60%] break-words">{{ record?.siteName || '-'
                }}</span>
            </div>
          </div>

          <div class="receipt-dashed-line"></div>

          <!-- Billing Items -->
          <div class="space-y-2 py-1">
            <div class="flex justify-between items-start text-[11.5px] receipt-text-dark">
              <span class="font-medium receipt-text-gray-500">รายการบริการ</span>
              <span class="font-bold receipt-text-dark text-right max-w-[60%] break-words">{{ record?.feeName || '-'
                }}</span>
            </div>
          </div>

          <div class="receipt-dashed-line"></div>

          <!-- Financial Summary — single line -->
          <div class="space-y-2 py-1">
            <div class="flex justify-between items-center text-[11.5px] receipt-text-dark">
              <span class="font-medium receipt-text-gray-500">ค่าบริการสุทธิ</span>
              <span class="font-bold receipt-text-dark">{{ record?.total | number:'1.2-2' }} ฿</span>
            </div>
          </div>

          <div class="receipt-double-dashed-line"></div>

          <!-- Grand Total -->
          <div class="py-1">
            <div class="flex justify-between items-center">
              <span class="text-[12px] font-extrabold uppercase tracking-widest receipt-text-dark">รวมทั้งสิ้น</span>
              <div class="flex items-baseline gap-1 receipt-text-dark">
                <span class="text-[20px] font-black receipt-mono tracking-tight">{{ record?.total | number:'1.2-2'
                  }}</span>
                <span class="text-[11px] font-bold">บาท</span>
              </div>
            </div>
          </div>

          <div class="receipt-dashed-line"></div>

          <!-- Barcode Graphic -->
          <div class="py-2 text-center" *ngIf="record?.receiptId">
            <div class="text-[9.5px] font-semibold receipt-text-dark tracking-[0.25em] mt-1.5 receipt-mono text-center">
              {{ record?.receiptId }}
            </div>
          </div>

          <div class="receipt-dashed-line"></div>

          <!-- Thank You -->
          <div class="text-center pt-1 pb-1">
            <p class="text-[10px] receipt-text-gray-500 font-bold uppercase tracking-wider receipt-mono">
              ขอบคุณที่ใช้บริการ / THANK YOU
            </p>
            <p class="text-[9px] receipt-text-gray-400 mt-0.5">PSS GROUP (THAILAND) Co., Ltd.</p>
          </div>

          <!-- Zigzag bottom -->
          <div class="zigzag-bottom">
            <svg class="w-full h-full text-white fill-current block" viewBox="0 0 100 10" preserveAspectRatio="none">
              <polygon
                points="0,0 2.5,10 5,0 7.5,10 10,0 12.5,10 15,0 17.5,10 20,0 22.5,10 25,0 27.5,10 30,0 32.5,10 35,0 37.5,10 40,0 42.5,10 45,0 47.5,10 50,0 52.5,10 55,0 57.5,10 60,0 62.5,10 65,0 67.5,10 70,0 72.5,10 75,0 77.5,10 80,0 82.5,10 85,0 87.5,10 90,0 92.5,10 95,0 97.5,10 100,0" />
            </svg>
          </div>

        </div>
      </div>
      <!-- ===== END PRINTABLE RECEIPT ===== -->

    </div>

    <!-- Action Buttons (non-printable, always visible at bottom) -->
    <div class="px-6 pb-6 pt-3 flex flex-col gap-2 flex-shrink-0 border-t border-slate-100 dark:border-slate-800/80">
      <div class="w-full flex flex-col gap-2">
        <!-- Request Full Tax -->
        <button *ngIf="canIssueFullTax" (click)="openIssueFullTaxModal()"
          class="w-full h-11 rounded-3xl bg-blue-500 hover:bg-blue-600 text-white font-bold text-[13px] flex items-center justify-center gap-2 transition-all active:scale-[0.98] shadow-[0_4px_12px_rgba(59,130,246,0.25)] border-none cursor-pointer">
          <span class="material-icons text-[16px]">request_quote</span>
          ขอใบกำกับภาษีเต็มรูป
        </button>

        <!-- Save PDF & Print Grid -->
        <div class="grid grid-cols-2 gap-2">
          <button (click)="downloadReceiptPdf()"
            class="w-full h-11 rounded-3xl bg-amber-400 hover:bg-amber-500 text-slate-950 font-bold text-[13px] flex items-center justify-center gap-2 transition-all active:scale-[0.98] shadow-[0_4px_12px_rgba(251,191,36,0.25)] border-none cursor-pointer">
            <span class="material-icons text-[16px]">download</span>
            บันทึก PDF
          </button>
          <button (click)="printReceipt()"
            class="w-full h-11 rounded-3xl bg-blue-50 hover:bg-blue-100 text-blue-600 font-bold text-[13px] flex items-center justify-center gap-2 transition-all active:scale-[0.98] border border-blue-100 dark:border-blue-900/30 cursor-pointer">
            <span class="material-icons text-[16px]">print</span>
            พิมพ์ใบเสร็จ
          </button>
        </div>
      </div>
      <!-- Close -->
      <button (click)="onClose()"
        class="w-full h-9 rounded-2xl bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 text-slate-500 dark:text-slate-400 font-semibold text-[12px] flex items-center justify-center gap-1.5 transition-all active:scale-[0.98] border-none cursor-pointer">
        <span class="material-icons text-[14px]">close</span>
        ปิดหน้าจอ
      </button>
    </div>

  </div>
</div>

<!-- PDF Loading Overlay (outside modal wrapper per project standard) -->
<div *ngIf="isGeneratingPdf" class="pdf-loading-overlay">
  <div class="pdf-loading-spinner"></div>
  <p class="pdf-loading-text">กำลังสร้างไฟล์ PDF...</p>
</div>

<app-modal-issue-full-tax-from-finance *ngIf="isIssueFullTaxModalOpen && record" [record]="record" [siteId]="siteId"
  [userId]="userId" [menuId]="menuId" (close)="closeIssueFullTaxModal()" (issued)="onIssueFullTaxSuccess($event)">
</app-modal-issue-full-tax-from-finance>